import styles from "./SecondaryButton.module.css"
import React from 'react';
import { ChevronRight } from 'lucide-react';
import { LucideIcon } from "lucide-react";
import { getColorVariantClass } from "../../../utils/classNames";

/**
* Props for the SecondaryButton component.
*/
interface SecondaryButtonTypes {
    text: string, // Button label
    disabled?: boolean, // Disable the button
    onClick: React.MouseEventHandler<HTMLButtonElement> // Click event handler
    className? :string, // Optional additional class
    Icon?: LucideIcon, // Optional custom icon
    showChevron?: boolean, // Whether to show icon
    colorVariant?: string // Color variant
    left?: boolean // Whether to show icon on the left
}
/**
* A with label and icon
*
* @param props SecondaryButton props
* @param {string} props.colorVariant - Color variant
* @param {string} props.text - Button label
* @param {boolean} props.disabled - Disable the button
* @param {string} props.className - Optional additional class
* @param {() => void} props.onClick - Function to call on click.
* @param {LucideIcon} props.Icon - Optional custom icon
* @param {boolean} props.showChevron - Whether to show icon
* @param {boolean} props.left - Whether to show icon on the left
* @returns TSX.Element
*/
const SecondaryButton = ({ text, disabled = false, onClick , className, Icon, showChevron = true, colorVariant = "neutral", left = false} : SecondaryButtonTypes) => {
    const buttonClassName = getColorVariantClass(styles, "SecondaryButton", {
        colorVariant,
        disabled,
        className,
    });

    return(
        <>
            <button onClick={onClick}
                className={buttonClassName}
                disabled={disabled}>
                {Icon && <Icon/>}<span>{text}</span>{showChevron && <ChevronRight />}
            </button>
        </>
    )
};

export default SecondaryButton; 